import parse from 'html-react-parser';
import { responseValidateQuestion } from '../../../../interfaces'

type TriviaReportItemProps = {
    question: responseValidateQuestion
}

export const TriviaReportItem = ({ question }: TriviaReportItemProps) => {
  return (
    <tr>
        <td style={{borderBottom: '.1rem solid #e6e6e6', fontSize: '1.15rem', width: '100%'}}>
            <table style={{border: '.1rem solid #ccc', padding: '1rem', width: '100%'}}>
                <tbody>
                    <tr>
                        <td style={{borderBottom: '.1rem solid #e6e6e6', fontSize: '1.3rem', fontWeight: 700, padding: '1.4rem 0', width: '100%'}}>{ parse(question.question?.pregunta || "") }</td>
                    </tr>
                    <tr>
                        <td style={{borderBottom: '.1rem solid #e6e6e6', fontSize: '1.15rem', width: '100%'}}>
                            <table style={{margin: '1rem 0', tableLayout: 'fixed', width: '100%'}}>
                                <thead>
                                    <tr>
                                        <th style={{borderBottom: 0, fontWeight: 700, padding: '0 1.5rem', textAlign: 'left'}}>Respuesta elegida</th>
                                        <th style={{borderBottom:0, fontWeight :700, padding: '0 1.5rem', textAlign: 'left'}}>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width:'100%'}}>{ parse(question.optionSelect?.texto || "") }</td>
                                        <td style={{backgroundColor: question.ok ? '#f9ce4e' : '#db143f', borderBottom: 0, color: '#fff', fontSize: '1.15rem', padding: '.5rem 1.5rem', textAlign: 'center', verticalAlign: 'middle', width: '100%'}}>
                                            {
                                                question.ok 
                                                ? <img src="https://polifoniaeditores.com/vpro2022/libros/public/images/c_icon.png" alt="" style={{height:64, width:64}}/>
                                                : <img src="https://polifoniaeditores.com/vpro2022/libros/public/images/ic_icon.png" alt="" style={{height:64, width:64}}/>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{borderBottom: '.1rem solid #e6e6e6', fontSize: '1.15rem', width: '100%'}}>
                            <table style={{margin: '1rem 0', tableLayout: 'fixed', width:'100%'}}>
                                <thead>
                                    <tr>
                                        <th style={{borderBottom: 0, fontWeight: 700, padding: '0 1.5rem', textAlign: 'left'}}>Respuesta correcta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width: '100%'}}>{ parse(question.optionCorrect?.texto || "") }</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{borderBottom: 0, fontSize: '1.15rem', width: '100%'}}>
                            <table style={{margin: '1rem 0', tableLayout: 'fixed', width: '100%'}}>
                                <thead>
                                    <tr>
                                        <th style={{borderBottom: 0, fontWeight:700, padding: '0 1.5rem', textAlign: 'left'}}>Justificación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{borderBottom: 0, fontSize: '1.15rem', padding: '.5rem 1.5rem', width: '100%'}}>{parse(question.question?.justificacion || '')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </td>
    </tr>
  )
}